import { Relatie } from '@/lib/types/relatie';
import { Form, Modal } from 'antd';
import { useEffect, useRef } from 'react';
import { getGroundDischargeError, getGroundReuseError } from '../../ground-water-rules';

export const useGroundWaterRules = (teeltwijze: number) => {
  const form = Form.useFormInstance<Relatie>();
  const jaar = Form.useWatch('registratiejaar', { form, preserve: true });
  const vormen = Form.useWatch('lozingsVorm', { form, preserve: true });
  const vormIndex = vormen?.findIndex(item => item?.betrekkingTotTeeltwijze === 0) ?? -1;
  const selectedVorm = vormen?.[vormIndex]?.value;
  const lastNotification = useRef<string | undefined>(undefined);
  const ground = teeltwijze === 0 && Number(jaar) >= 2026;
  const dependencies = ground && vormIndex >= 0 ? [['lozingsVorm', vormIndex, 'value']] : [];
  useEffect(() => {
    lastNotification.current = undefined;
  }, [selectedVorm]);
  const getVorm = () => {
    const values: Relatie['lozingsVorm'] | undefined = form.getFieldValue('lozingsVorm');
    return values?.find(item => item?.betrekkingTotTeeltwijze === 0)?.value;
  };
  const validate = (getError: typeof getGroundDischargeError) => async (_rule: unknown, value?: number | null) => {
    const message = ground ? getError(getVorm(), value) : undefined;
    if (message) throw new Error(message);
  };
  const showError = (
    getError: typeof getGroundDischargeError,
    groupIndex: number,
    rowIndex: number,
    field: keyof Relatie['lozingen'][number]['lozingen'][number]
  ) => {
    const value: number | undefined = form.getFieldValue(['lozingen', groupIndex, 'lozingen', rowIndex, field]);
    const vorm = getVorm();
    const message = ground ? getError(vorm, value) : undefined;
    const snapshot = `${groupIndex}:${rowIndex}:${field}:${vorm}:${value}`;
    if (message && lastNotification.current !== snapshot) {
      lastNotification.current = snapshot;
      Modal.error({ title: 'Controleer uw invoer', content: message });
    }
    if (!message) lastNotification.current = undefined;
  };
  return {
    ground,
    dependencies,
    dischargeValidator: validate(getGroundDischargeError),
    reuseValidator: validate(getGroundReuseError),
    onDischargeBlur: (group: number, row: number, field: keyof Relatie['lozingen'][number]['lozingen'][number]) =>
      showError(getGroundDischargeError, group, row, field),
    onReuseBlur: (group: number, row: number) => showError(getGroundReuseError, group, row, 'hergebruiktDrainagewaterHoeveelheid'),
  };
};
